import {
    APIProvider,
    Map,
    Marker,
    useAdvancedMarkerRef,
} from "@vis.gl/react-google-maps";
import React, { useState } from "react";
import { GOOGLE_MAP_API_KEY } from "../../constants/routes";
import cn from "../../lib/cn";
import MapHandler from "./MapHandler";
import PlaceAutocomplete from "./PlaceAutoComplete";
const API_KEY = GOOGLE_MAP_API_KEY;

const GoogleMap = ({
    onPlaceSelect,
    autocompleteInput,
    className,
    position,
    setPosition,
}) => {
    const [selectedPlace, setSelectedPlace] = useState(null);
    const [markerRef, marker] = useAdvancedMarkerRef();

    const handlePlaceChanged = (place) => {
        if (!place || !place.geometry) {
            return;
        }
        const lat = place.geometry.location.lat();
        const lng = place.geometry.location.lng();
        setSelectedPlace(place);
        setPosition({ lat, lng });
        onPlaceSelect(place);
    };

    return (
        <div className={cn(className)}>
            <APIProvider apiKey={API_KEY}>
                {autocompleteInput && (
                    <>
                        <div>{autocompleteInput}</div>

                        <PlaceAutocomplete
                            onPlaceSelect={handlePlaceChanged}
                            inputRef={autocompleteInput?.ref}
                        />
                    </>
                )}

                <Map
                    className="w-full h-[200px]"
                    zoom={15}
                    // defaultCenter={position}
                    center={position}
                    gestureHandling={"greedy"}
                    streetViewControl={false}
                    mapTypeControl={false}
                    // draggingCursor={}
                >
                    <Marker ref={markerRef} position={position} />
                </Map>
                <MapHandler place={selectedPlace} marker={marker} />
            </APIProvider>
        </div>
    );
};

export default GoogleMap;
